<template>
    <div>
        <b-modal :active.sync="showSearchModal" :id="`search_${type}_modal`" aria-modal :width="885">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ type == 'boxes' ? 'Box' : 'Product' }} zoeken</p>
                    <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                        <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                    </b-tooltip>
                </header>
                <section class="modal-card-body">
                    <b-field :label="type == 'boxes' ? 'Zoek een box' : 'Zoek een product'">
                        <b-input v-model="searchQuery" :placeholder="type == 'boxes' ? 'Zoek op nummer' : 'Zoek op naam'" :loading="loading"></b-input>
                    </b-field>

                    <!-- <div class="row" v-if="user && user.role === 'pit'">
                        <div class="column paddingtop0">
                            <b-field label="Organisatie">
                                <b-select v-model="dataBelongsTo" class="databelongsto" expanded>
                                    <option value="all">Alle (organisaties)</option>
                                    <option
                                        v-for="(organisation, id) in organisations"
                                        :value="id"
                                        :key="id"
                                    >(ID: {{ organisation.id }}) {{ organisation.name }}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div> -->

                    <b-table
                        :data="searchResults"
                        :narrowed="true"

                        backend-pagination
                        :total="total"
                        :per-page="perPage"
                        @page-change="onPageChange"
                        backend-sorting
                        :default-sort-direction="sortOrder"
                        :default-sort="[sortField, sortOrder]"
                        @sort="onSort"
                        :paginated="paginated"
                        :loading="loading"
                        :sort-icon="'chevron-up'"
                        v-if="searchResults && searchResults.length"
                    >
                        <template>
                            <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && dataBelongsTo === 'all'" class="admin">
                                <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                                    {{ organisations[props.row.organisation].short_name }}
                                </b-button>
                            </b-table-column>

                            <b-table-column v-slot="props" field="number" label="Nummer" width="100" :visible="type == 'boxes'" sortable>
                                {{ props.row.number }}
                            </b-table-column>
                            <b-table-column v-slot="props" field="name" label="Naam" width="200" :visible="type == 'products'" sortable>
                                {{ props.row.name }}
                            </b-table-column>

                            <b-table-column v-slot="props" field="status" label="Status" width="200" :visible="type == 'boxes'" sortable>
                                <BoxesOverviewStatus
                                    :status="props.row.status"
                                    :available_at="props.row.available_at"
                                    available_at_type="plain"
                                />
                            </b-table-column>

                            <b-table-column v-slot="props" field="size" width="125" label="Inhoud" class="show-for-large" :visible="type == 'boxes'">
                                {{ props.row.size }}m³

                                <b-tooltip :label="`LxBxH: ${props.row.length ? props.row.length : '-'} x ${props.row.width ? props.row.width : '-'} x ${props.row.height ? props.row.height : '-'}`" v-if="props.row.length && props.row.width">
                                    <b-icon size="is-small" icon="info-circle" />
                                </b-tooltip>
                            </b-table-column>

                            <b-table-column v-slot="props" field="price" label="Prijs" width="100" numeric sortable>
                                <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                                <span v-else-if="props.row.price > 0">&euro;&nbsp;{{ props.row.price }}</span>
                                <span v-else>-</span>
                            </b-table-column>

                            <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" width="150" sortable>
                                <span>{{ props.row.updated_at|humanDate }}</span>
                            </b-table-column>

                            <b-table-column v-slot="props" numeric width="55">
                                <b-button type="is-danger" @click="removeProduct(props.row.id)" v-if="isProductSelected(props.row.id)" icon-right="trash-alt" />
                                <b-button type="is-success" @click="addProduct(props.row)" v-else icon-right="check" />
                            </b-table-column>
                        </template>
                    </b-table>
                    <span v-else-if="!loading && results.length === 0" class="text-center">
                        <br><h4>Geen {{ type == 'boxes' ? 'boxen' : 'producten' }} gevonden.</h4><br>
                    </span>

                    <div class="column text-right">
                        <b-button type="is-light" @click="closeModal" :loading="loading">Sluiten</b-button>
                    </div>
                </section>
            </div>
        </b-modal>

        <!-- Discount Modal -->
        <discount-modal
            :is-open="showDiscountModal"
            :product-price="currentProductPrice"
            :existing-discounts="currentProductDiscount"
            @close="showDiscountModal = false"
            @apply="applyDiscount"
            @remove="removeDiscount"
        />

        <div v-if="!onlyModal">
            <b-notification v-if="invalidBoxReservation && type == 'boxes'" type="is-danger is-light" role="alert">
                <h3>Let op!</h3>
                <p>
                    {{ records.length > 1 ? 'Eén van de door jou gekozen boxen is nog niet beschikbaar op de gekozen startdatum!' : 'De box is nog niet beschikbaar op de gekozen startdatum!' }}
                </p>
            </b-notification>

            <div v-if="records && records.length">
                <b-table
                    :data="records"
                    :narrowed="true"
                    :key="key"
                >
                    <template>
                        <!-- <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit'" class="admin">
                            <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                                {{ organisations[props.row.organisation].short_name }}
                            </b-button>
                        </b-table-column> -->
                        <b-table-column v-slot="props" field="number" label="Nummer" width="100" :visible="type == 'boxes'">
                            {{ props.row.number ? props.row.number : props.row.name }}
                        </b-table-column>
                        <b-table-column v-slot="props" field="name" label="Naam" width="200" :visible="type == 'products'">
                            <b-input v-model="props.row.name" :disabled="!props.row.id"></b-input>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Eenmalig (?)" width="100" :visible="type == 'products'">
                            <template slot="header">
                                <b-tooltip label="Alleen op de eerste factuur meenemen. Product verkopen, geen verhuur." position="is-bottom" dashed>
                                    Eenmalig(?)
                                </b-tooltip>
                            </template>
                            <b-checkbox
                                :value="props.row.once"
                                @input="value => onceChanged(props.row.id, value)"
                                v-if="mode == 'new'"
                            ></b-checkbox>
                            <span v-else>{{ props.row.once ? 'Ja' : 'Nee' }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="price" :label="`Bedrag${type == 'boxes' && ['quarter', 'halfyear', 'year'].includes(record.step1.invoice_freq) ? ' (per maand)' : ''}`" width="200">
                            <b-field :type="props.row.price < 0 ? 'is-danger' : ''" :message="props.row.price < 0 ? 'Prijs mag niet negatief zijn' : ''">
                                <b-input v-model="props.row.price" type="number" min="0" step="0.01"></b-input>
                            </b-field>
                        </b-table-column>

                        <b-table-column v-slot="props" field="btw" :label="`BTW`" width="100">
                            <b-field :type="props.row.btw < 0 ? 'is-danger' : ''" :message="props.row.btw < 0 ? 'BTW mag niet negatief zijn' : ''">
                                <b-input v-model="props.row.btw" type="number" min="0" step="0.01"></b-input>
                            </b-field>
                        </b-table-column>

                        <b-table-column v-slot="props" :label="`Borg ${type == 'products' ? '(per stuk)' : ''}`" width="200">
                            <b-field :type="(props.row.once && props.row.deposit > 0) || props.row.deposit < 0 ? 'is-danger' : ''"
                                    :message="props.row.deposit < 0 ? 'Borg mag niet negatief zijn' : (props.row.once && props.row.deposit > 0 ? 'Borg is ongebruikelijk bij een eenmalig product!' : '')">
                                <b-input v-model="props.row.deposit" type="number" min="0" step="0.01"></b-input>
                            </b-field>
                        </b-table-column>

                        <b-table-column v-slot="props" :label="`Aantal${record.step1.invoice_freq === 'quarter' || record.step1.invoice_freq === 'halfyear' || record.step1.invoice_freq === 'year' ? ' (per maand)' : ''}`" width="150px" :visible="type == 'products'">
                            <b-field :type="props.row.amount < 0 ? 'is-danger' : ''" :message="props.row.amount < 0 ? 'Aantal mag niet negatief zijn' : ''">
                                <b-input v-model="props.row.amount" type="number" min="0" step="1" v-if="mode == 'new'"></b-input>
                                <span v-else>{{ props.row.amount }}x</span>
                            </b-field>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Korting" width="150">
                            <b-button
                                type="is-info"
                                icon-left="percent"
                                @click="openDiscountModal(props.row)"
                                :outlined="!hasDiscount(props.row.id)"
                                v-if="mode == 'new'"
                            >
                                {{ getDiscountDisplay(props.row) }}
                            </b-button>
                            <span v-else-if="props.row.discount">
                                {{ getDiscountDisplay(props.row) }}
                            </span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="100">
                            <b-button type="is-danger" @click="removeProduct(props.row.id)" v-if="mode == 'new'">Verwijderen</b-button>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
            <div v-else>
                <p>Geen {{ type == 'boxes' ? 'boxen' : 'producten' }} gekoppeld.</p>
            </div>

            <br>
            <b-button @click="addNewProduct" type="is-primary" outlined v-if="mode == 'new' && type == 'products'">Product toevoegen</b-button>
            <b-button @click="showModal" type="is-primary" v-if="mode == 'new'">{{ type == 'products' ? 'Product zoeken' : 'Box zoeken' }}</b-button>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import BoxesOverviewStatus from '@/vue/products/BoxesOverviewStatus'
import DiscountModal from '@/vue/discounts/DiscountModal'
import filtersMixin from '@/mixins/filterMixins'
import { debounce } from 'lodash'

export default {
    name: 'ContractRecordProducts',

    mixins: [filtersMixin],

    props: {
        type: {
            type: String,
            required: true,
        },
        record: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
        startDate: {
            type: Date,
            required: false,
            default: null
        },
        onlyModal: {
            type: Boolean,
            required: false,
            default: false
        },
        organisation: {
            type: [Number, String],
            required: false,
            default: null
        }
    },

    components: {
        BoxesOverviewStatus,
        DiscountModal
    },

    data () {
        return {
            key: 0,
            total: 0,
            page: 1,
            perPage: 15,
            sortField: 'updated_at',
            sortOrder: 'desc',
            loading: false,
            showSearchModal: false,
            dataBelongsTo: this.user?.organisation || null,
            searchQuery: '',
            searchResults: [],
            selectedProducts: [],
            showDiscountModal: false,
            currentProductPrice: null,
            currentProductDiscount: null,
            currentProductRow: null
        }
    },

    created() {
        this.debouncedFindProduct = debounce(() => {
            this.findProduct()
        }, 300)

        if (this.user && this.user.role === 'pit') {
            this.dataBelongsTo = this.user.organisation
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        organisations() {
            return this.$store.state.organisations || null
        },

        paginated(){
            return this.results.length < this.total
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        records: {
            get() {
                if (this.onlyModal) {
                    return this.selectedProducts
                }
                return this.$store.getters['contract/getProducts'](this.type)
            },
            set(value) {
                if (this.onlyModal) {
                    this.selectedProducts = value
                } else {
                    console.warn('Attempting to directly set records - use Vuex mutations instead')
                }
            }
        },

        invalidBoxReservation() {
            let invalid = false

            if(this.type == 'boxes' && !_.isNull(this.startDate)) {
                _.each(this.records, (box) => {
                    if(!_.isNull(box.available_at) && moment(box.available_at).format('YMMDD') > moment(this.startDate).format('YMMDD')){
                        invalid = true
                    }
                })
            }

            this.$emit('nextStepBlockedByInvalidBox', invalid)
            return invalid
        },

        results() {
            if (this.type === 'boxes') {
                return this.searchResults.filter(record => record.type === 'box')
            }
            return this.searchResults.filter(record => record.type === 'product')
        }
    },

    methods: {
        showModal(products = []) {
            this.showSearchModal = true

            if (products && products.length) {
                if (this.onlyModal) {
                    this.selectedProducts = products
                } else {
                    this.records = products
                }
            }

            // Only fetch products if we don't have any search results yet
            if (!this.searchResults.length) {
                this.findProduct()
            }
        },

        closeModal(){
            this.showSearchModal = false
        },

        findProduct() {
            console.log('Start searching products for:', this.type)
            this.loading = true

            let params = [
                `paginate=${this.perPage}`,
                `sort_by=${this.sortField}.${this.sortOrder}`,
                `page=${this.page}`
            ]

            if (this.dataBelongsTo && this.dataBelongsTo !== 'all' && this.user.role === 'pit') {
                params.push(`organisation=${this.dataBelongsTo}`)
            }

            if (this.searchQuery) {
                params.push(`search=${this.searchQuery}`)
            }

            params = params.join('&')

            axios.get(`/api/contract-products?type=${this.type}&${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.total = response.data.total
                this.page = response.data.current_page
                this.searchResults = response.data.data
            }).catch((error) => {
                console.log(`[❌] Error while fetching products for type ${this.type}`, error)
                this.$buefy.toast.open({message: `${this.type == 'boxes' ? 'Boxen' : 'Producten'} kunnen niet geladen worden.`, type: 'is-danger'})
            }).then(() => {
                this.loading = false
            })
        },

        addProduct(product) {
            if (this.onlyModal) {
                // For loose invoices, add to local array and emit
                this.selectedProducts = [...this.selectedProducts, product]
                this.$emit('passProducts', { records: this.selectedProducts })
            } else {
                // For contracts, use Vuex store
                this.$store.dispatch('contract/addProduct', { type: this.type, product })
            }

            if (this.type == 'boxes') {
                this.closeModal()
            }
        },

        removeProduct(id) {
            if (this.onlyModal) {
                // For loose invoices, remove from local array and emit
                this.selectedProducts = this.selectedProducts.filter(product => product.id !== id)
                this.$emit('passProducts', { records: this.selectedProducts })
            } else {
                // For contracts, use Vuex store
                this.$store.dispatch('contract/removeProduct', { type: this.type, id })
            }
        },

        removeAllProducts() {
            this.$store.dispatch('contract/clearProducts', this.type)
        },

        isProductSelected(id) {
            if (this.onlyModal) {
                // For loose invoices, check local selectedProducts array
                return this.selectedProducts.some(product => product.id === id)
            }
            // For contracts, use Vuex store
            return this.$store.getters['contract/isProductSelected'](this.type, id)
        },

        onceChanged(id, value) {
            this.$store.dispatch('contract/setProductProperty', {
                type: this.type,
                id,
                property: 'once',
                value
            })
            Vue.set(this, 'key', ++this.key)
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.findProduct()
        },

        onPageChange(page) {
            this.page = page
            this.findProduct()
        },

        addNewProduct() {
            const product = {
                id: Math.floor(100000000 + Math.random() * 900000000), // random to delete
                amount: 1,
                btw: '21.00',
                deposit: '0.00',
                name: '',
                price: '0.00',
                once: true,
                organisation: this.organisation,
                type: 'product',
                product: null,
                totalType: 'price'
            }

            if (this.onlyModal) {
                this.selectedProducts.push(product)
                this.$emit('passProducts', { records: this.selectedProducts })
            } else {
                this.$store.dispatch('contract/addProduct', { type: this.type, product })
            }
        },

        openDiscountModal(row) {
            this.currentProductRow = row
            this.currentProductPrice = parseFloat(row.price) || 0
            
            // Get existing discounts from Vuex store
            const storedDiscount = this.$store.getters['contract/getProductDiscounts'](this.type, row.id)
            this.currentProductDiscount = storedDiscount.discounts || []
            
            this.showDiscountModal = true
        },

        applyDiscount(discountsData) {
            if (this.currentProductRow) {
                // Store discounts in Vuex
                this.$store.dispatch('contract/setProductDiscounts', {
                    productId: this.currentProductRow.id,
                    type: this.type,
                    discounts: discountsData.discounts,
                    applyToAll: discountsData.applyToAll
                })

                // Update the key to force re-render
                this.key++
            }
            this.showDiscountModal = false
        },

        removeDiscount() {
            if (this.currentProductRow) {
                // Remove discounts from Vuex store
                this.$store.dispatch('contract/setProductDiscounts', {
                    productId: this.currentProductRow.id,
                    type: this.type,
                    discounts: [],
                    applyToAll: true
                })

                // Update the key to force re-render
                this.key++
            }
            this.showDiscountModal = false
        },

        hasDiscount(productId) {
            const discount = this.$store.getters['contract/getProductDiscounts'](this.type, productId)
            return discount && discount.discounts && discount.discounts.length > 0
        },

        getDiscountDisplay(row) {
            const discount = this.$store.getters['contract/getProductDiscounts'](this.type, row.id)
            
            if (!discount || !discount.discounts || discount.discounts.length === 0) {
                return 'Korting'
            }

            // If apply to all with single discount, show details
            if (discount.applyToAll && discount.discounts.length === 1) {
                const firstDiscount = discount.discounts[0]
                if (firstDiscount.type === 'percentage') {
                    return `${firstDiscount.value}%`
                }
                return `€${firstDiscount.value}`
            }

            // Show number of discounts configured
            return `${discount.discounts.length} ${discount.discounts.length > 1 ? 'kortingen' : 'korting'}`
        }
    },

    watch: {
        organisation: {
            handler(newVal){
                if(newVal){
                    this.dataBelongsTo = newVal
                }
            }, immediate: true
        },
        dataBelongsTo: {
            handler(newVal){
                if(newVal){
                    this.page = 1
                    this.findProduct()
                }
            }, immediate: true
        },
        searchQuery: {
            handler() {
                this.page = 1
                this.debouncedFindProduct()
            }
        }
    }
}
</script>
